const MAX_LAN_ORIGINS = 8;
export class LanCandidateRefreshService {
    #identity;
    #now;
    constructor(options) {
        this.#identity = options.identity;
        this.#now = options.now ?? (() => new Date().toISOString());
    }
    async refresh(home) {
        const current = await this.#identity.loadConnectionMetadata();
        const homeNodeId = current?.homeNodeId;
        if (!isNodeId(homeNodeId))
            throw new TypeError("Home node transport identity is not established");
        const response = await home.invoke({
            operation: "GET /api/v2/client-transport/candidates",
            payload: {},
        });
        const refreshed = parseCandidates(response, homeNodeId);
        const next = {
            directAddresses: refreshed.lan.map((candidate) => candidate.address),
            homeNodeId,
            lastConnectedAt: this.#now(),
            ...(current?.relayUrl === undefined ? {} : { relayUrl: current.relayUrl }),
            wanOrigin: refreshed.wan.address,
        };
        await this.#identity.storeConnectionMetadata(next);
        return refreshed.lan;
    }
}
function parseCandidates(value, expectedHomeNodeId) {
    if (!isExactCandidateResponse(value) || value.node_id !== expectedHomeNodeId) {
        throw new TypeError("Home node transport identity did not match");
    }
    const lan = normalizeLanOrigins(value.lan_origins);
    const wan = canonicalHttpsOrigin(value.wan_origin, "Home node WAN origin was invalid");
    return {
        lan: lan.map((address) => ({ address, id: expectedHomeNodeId, path: "lan-direct" })),
        wan: { address: wan, id: expectedHomeNodeId, path: "wan-direct" },
    };
}
function normalizeLanOrigins(origins) {
    const normalized = new Set();
    for (const origin of origins) {
        normalized.add(canonicalHttpsOrigin(origin, "Home node LAN candidates were invalid"));
        if (normalized.size === MAX_LAN_ORIGINS)
            break;
    }
    return [...normalized];
}
function canonicalHttpsOrigin(value, message) {
    let url;
    try {
        url = new URL(value);
    }
    catch {
        throw new TypeError(message);
    }
    if (url.protocol !== "https:" || url.username !== "" || url.password !== "" || url.hostname === "" || url.origin !== value) {
        throw new TypeError(message);
    }
    return url.origin;
}
function isExactCandidateResponse(value) {
    if (!isRecord(value))
        return false;
    const record = value;
    const expected = ["lan_origins", "node_id", "version", "wan_origin"];
    if (Object.keys(record).length !== expected.length || !expected.every((key) => Object.hasOwn(record, key)))
        return false;
    return record.version === 1 && isNodeId(record.node_id) && typeof record.wan_origin === "string" &&
        Array.isArray(record.lan_origins) && record.lan_origins.every((origin) => typeof origin === "string");
}
function isRecord(value) {
    return typeof value === "object" && value !== null && !Array.isArray(value);
}
function isNodeId(value) {
    return typeof value === "string" && value.trim() === value && value.length > 0;
}
//# sourceMappingURL=lan-candidate-refresh-service.js.map